import { makeStyles } from '@skill-survey/theme';
import type { ReactNode } from 'react';

// 960px + 96px for padding on each side
// (960 + 96) / 4 = 264 sizing units
const maxWidth = 264;

const useStyles = makeStyles(({ sizing, spacing, breakpoints }) => ({
  root: {
    margin: '0 auto',
    width: '100%',
    padding: spacing(0, 6),
    [breakpoints.up('md')]: {
      padding: spacing(0, 10),
      maxWidth: sizing(maxWidth),
    },
  },
}));

type Props = {
  children: ReactNode;
  className?: string;
};

const Container = ({ children, className }: Props) => {
  const { classes, cx } = useStyles();
  return <div className={cx(classes.root, className)}>{children}</div>;
};

export default Container;
